export default "__VITE_ASSET__Iwa3CX1m__"